// Copyright (c) 2024 WiseTime. All rights reserved.

import { concat, EMPTY, Observable, of } from "rxjs"
import { Action } from "redux"
import { filter, mergeMap, withLatestFrom } from "rxjs/operators"
import * as Actions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { showSnackBar, validationSnackBarPayload } from "../../snackbar/actions"
import { RootState } from "../../../app/store"
import * as UserContextSlice from "../../user-context/slice"
import { validateTimeGroupsForPost } from "../timeBlocks"
import { TimeGroup } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

export const postTimeGroup = () =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(Actions.postTimeGroup.match),
      mergeMap(action => of(action.payload)
        .pipe(
          withLatestFrom(state$),
          mergeMap(([timeGroup, state]) => {
            const currentSite = UserContextSlice.selectCurrentSite(state)
            const currentSiteRef = UserContextSlice.selectCurrentSiteRef(state)
            const timesheetFieldConfigsCache = TimelineSlice.selectTimesheetFieldConfigsCache(state)
            const timeGroupFieldConfigsCache = TimelineSlice.selectTimeGroupFieldConfigsCache(state)
            if (!currentSite || !currentSiteRef) {
              return EMPTY
            }
            const timeGroups: TimeGroup.AsObject[] = [timeGroup]
            const validationResult = validateTimeGroupsForPost(
              currentSite,
              timeGroups,
              timesheetFieldConfigsCache,
              timeGroupFieldConfigsCache,
            )
            const actions: Action[] = []
            if (Object.keys(validationResult.errorMessages).length > 0) {
              actions.push(TimelineSlice.setTimeGroupsPostErrorMessages(validationResult.errorMessages))
              validationResult.snackBarError && actions.push(
                showSnackBar(validationSnackBarPayload(validationResult.snackBarError))
              )
            } else {
              actions.push(
                Actions.postTime({
                  timeGroups,
                  currentSiteRef,
                  roundingPreferenceSec: currentSite.roundingPreferenceSec,
                })
              )
            }
            return concat(actions)
          }),
        )
      ),
    )

export default postTimeGroup()
